import * as React from "react";
const SvgIcCaretRight = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 16" {...props}><path fill="currentColor" d="M7.62 7.18 2.79 3.03c-.7-.6-1.79-.1-1.79.82v8.29c0 .93 1.09 1.42 1.79.82l4.83-4.14c.5-.43.5-1.21 0-1.64Z" /></svg>;
export default SvgIcCaretRight;